import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Icon, Input, Badge, Spin, message, Button } from 'antd';
import * as S from '../styles';
import { useBatchJob } from '../../../../../context/BatchJobContext';
import axiosCall from '../../../../../utils/services/interceptor';
import { Document, Page } from 'react-pdf';
import axios from 'axios';
import { saveByteArray } from '../../../../../utils/javascript';
import { PreviewPageWithObserver } from '../../../../ComplexDocumentDesign/ComplexPdfInserts/InsertPreviewModal';
import { proceedProof } from '../../../../../utils/services/statusMonitoringAPI';
import { getSearchMetaKeys } from '../../../../../utils/services/statusMonitoringAPI';
import ProofSearchSelect from './ProofSearchSelect';
import { proofApproval } from '../../../../../utils/services/statusMonitoringAPI';
import { LoaderContainer } from '../../../../TemplateSection/styles';
import Loader from '../../../../../components/Loader';
import { BATCH_JOBS_DASHBOARD as trans } from '../translationValues';
import { useTranslation } from 'react-i18next';
import { PreviewIframe } from '../../../../ComplexEmailDesign/ComplexEmailPreview/styles';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

const NAMESPACE = ['BATCH_JOBS_DASHBOARD'];

export function ProofViewer({ format, selectedTemplate, templates, proofs, ...props }) {
    const { t } = useTranslation(NAMESPACE);
    const { isDraft, uploadedFile } = props;

    const STATIC_STATS_KEYS = ['uniq_id', 'uniq_name'];

    const { proffDataList, setProffDataList, batchId,  proofsApproved, setProofsApproved,totalProofCount,setTotalProofCount, isProofsTab = false} = props;
    const [pdfurl, setPdfUrl] = useState();
    const [emailData, setEmailData] = useState();
    const [numPages, setNumPages] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [totalCount, setTotalCount] = useState(0);
    const [currentView, setCurrentView] = useState(2);
    const [metaKeys, setMetaKeys] = useState(STATIC_STATS_KEYS);
    const [noSearchResult, setNoSearchResult] = useState(false);
    const [isApproving, setIsApproving] = useState(false);
    const [isNoDocUrlFound, setIsNoDocUrlFound] = useState(false);
    const isApproved = useRef(false);
    const currentChannel = useRef('print');
    const reqIdRef = useRef(0);

    const getPreview = async (url, payload) => {
        if(!url){
            setIsLoading(false);
            setIsNoDocUrlFound(true);
            return;
        }
        setNumPages(null);
        noSearchResult && setNoSearchResult(false)
        currentChannel.current = 'print';
        let req = { dataSet: payload };
        let res;
        try {
            let response = await axiosCall('post', url, req, true, false, true);
            if (response?.status === 200) {
                res = { status: response?.status, url: saveByteArray('kk77', response.data, false) };
            }
            setPdfUrl(res?.url);
            setIsLoading(false);
        }
        catch (error) {
            console.error("Failed to load PDF preview:", error);
            setIsLoading(false);
            setPdfUrl(null);
            message.error(t(trans.FAILED_TO_LOAD_PDF.key, trans.FAILED_TO_LOAD_PDF.value));
        }
    }

    const getEmailPreview = async (url, payload) => {
        if(!url){
            setIsLoading(false);
            setIsNoDocUrlFound(true);
            return;
        }
        noSearchResult && setNoSearchResult(false)
        currentChannel.current = 'email';
        let req = { dataSet: payload };
        try {
            let response = await axiosCall('post', url, req);
            if (response?.status === 200) {
                setEmailData(response?.data);
            }
            setIsLoading(false);
        }
        catch (error) {
            console.error("Failed to load email preview:", error);
            setIsLoading(false);
            setEmailData(null);
            message.error(t(trans.FAILED_TO_LOAD_EMAIL.key, trans.FAILED_TO_LOAD_EMAIL.value));
        }
    }

    const getMetaKeys = async () => {
        try {
            const { data = [] } = await getSearchMetaKeys(batchId);

            if (!Array.isArray(data)) return;

            setMetaKeys(prev => [...prev, ...data]);
        } catch (error) {
            console.error("Failed to fetch meta keys:", error);
            message.error(t(trans.META_KEYS_FETCH_FAILED.key, trans.META_KEYS_FETCH_FAILED.value))      
        }
    };

    useEffect(() => {
        if (!proffDataList || proffDataList.length === 0) return;
        const isMulti = format.toLowerCase() === 'multichannel' || format.toLowerCase() === 'multi channel';
        const currentChannelForPreview = isMulti ? selectedChannel : format;
        
        if (currentChannelForPreview?.toLowerCase() === 'print') {
            getPreview(proffDataList[0]?.documentURL, proffDataList[0]?.dataSet);
        }
        else if (currentChannelForPreview?.toLowerCase() === 'email') {
            getEmailPreview(proffDataList[0]?.documentURL, proffDataList[0]?.dataSet);
        }
    }, [proffDataList])

    useEffect(() => {
        if(isDraft && !uploadedFile) {
            getProofsList(0);
        }
        getMetaKeys();
    }, []);

    const getProofsList = async (index = 4, isLastFiveProofs = false) => {
        let payload = {
            search: [
                {
                    fieldName: 'stage',
                    value: 'yet_to_start'
                },
                {
                    fieldName: 'channel',
                    value: selectedChannel?.toLowerCase()
                }
            ],
            jobId: String(batchId),
            // ...( isLastFiveProofs && { lastFiveProofs: true }),
        }
        try {
            let response = await proceedProof(payload, isLastFiveProofs );
            if (response && response?.data) {
                getPreview(response?.data.proofs[index]?.documentURL, response?.data?.proofs[index]?.dataSet);
                setProffDataList(response?.data?.proofs);
                if(index === 0) {
                    setTotalProofCount({ print: response?.data?.printCount, email: response?.data?.emailCount });
                }
            }
            setIsLoading(false);
        }
        catch (error) {
            console.error("Failed to fetch proofs:", error);
            setIsLoading(false);
            message.error(t(trans.PROOFS_FETCH_FAILED.key, trans.PROOFS_FETCH_FAILED.value));
        }
    }

    const getProofsListForMultiChannel = async (channelId) => {
        const currentReqId = ++reqIdRef.current;
        let payload = {
            search: [
                {
                    fieldName: 'stage',
                    value: 'yet_to_start'
                },
                {
                    fieldName: 'channel',
                    value: (format?.toLowerCase() === "multichannel" || format?.toLowerCase() === "multi channel") ? channelId?.toLowerCase() : format?.toLowerCase()
                }
            ],
            jobId: String(batchId)
        }
        try {
            let response = await proceedProof(payload);
            if (currentReqId !== reqIdRef.current) return;
            if (response && response?.data) {
                setTotalProofCount({ print: response?.data?.printCount, email: response?.data?.emailCount });
                if (channelId === 'PRINT') {
                    getPreview(response?.data?.proofs[0]?.documentURL, response?.data?.proofs[0]?.dataSet);
                }
                else if (channelId === 'EMAIL') {
                    getEmailPreview(response?.data?.proofs[0]?.documentURL, response?.data?.proofs[0]?.dataSet);
                }
                setProffDataList(response?.data?.proofs);
            }
        }
        catch (error) {
            if (currentReqId !== reqIdRef.current) return;
            console.error("Failed to fetch multichannel proofs:", error);
            message.error(t(trans.PROOFS_FETCH_FAILED.key, trans.PROOFS_FETCH_FAILED.value));
        }
    }

    const isMultichannel = format === 'MULTICHANNEL' || format === 'MULTI CHANNEL' || format === 'multiChannel' || format === 'HYBRID' ||
        (proofs && proofs.length > 0 && proofs.some(p => p.channel));

    const getUniqueChannels = () => {
        if (!proofs || proofs.length === 0) return [];
        const channels = [...new Set(proofs.map(p => p.channel))].filter(Boolean);
        return channels.map(ch => ({
            id: ch,
            label: ch,
            count: proofs.filter(p => p.channel === ch).length
        }));
    };

    const actualChannels = proofs && proofs.length > 0 ? getUniqueChannels() : [];
    const initialChannel = actualChannels.length > 0 ? actualChannels[0].id :
        (isMultichannel ? 'PRINT' : format);

    const [selectedChannel, setSelectedChannel] = useState(initialChannel);
    const [selectedProofNumber, setSelectedProofNumber] = useState(0);
    const [viewMode, setViewMode] = useState('desktop');
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedFilters, setSelectedFilters] = useState([]);

    const [showSearch, setShowSearch] = useState(false);
    const [selectedProofs, setSelectedProofs] = useState([]);

    const mockProofs = [
        {
            id: 1,
            name: 'Sarah Johnson',
            email: 'sarah.johnson@example.com',
            phone: '+44 7700 900123',
            address: '123 Example Street',
            city: 'London',
            postcode: 'SW1A 1AA',
            company: 'Go Inspire',
            companyAddress: 'PO Box 227',
            companyCity: 'Rotherham',
            companyPostcode: 'S98 1PB',
            date: '24 December 2025',
            ref: 'REF:4TV',
            customerId: 'CUS7',
            subject: 'We Missed Your Service Visit - Let\'s Make It Right',
            message: 'We wanted to get you an annual service visit with us, but we didn\'t invite you to book it in like we should have. We apologize for this oversight and would like to make it up to you.',
        },
        {
            id: 2,
            name: 'Michael Chen',
            email: 'michael.chen@example.com',
            phone: '+44 7700 900456',
            address: '456 Park Avenue',
            city: 'Manchester',
            postcode: 'M1 1AE',
            company: 'Go Inspire',
            companyAddress: 'PO Box 227',
            companyCity: 'Rotherham',
            companyPostcode: 'S98 1PB',
            date: '24 December 2025',
            ref: 'REF:8XY',
            customerId: 'CUS12',
            subject: 'Important Service Update',
            message: 'Thank you for your continued support. We wanted to reach out regarding your annual maintenance schedule.',
        },
        {
            id: 3,
            name: 'Emma Williams',
            email: 'emma.williams@example.com',
            phone: '+44 7700 900789',
            address: '789 Queen Street',
            city: 'Birmingham',
            postcode: 'B1 1AA',
            company: 'Go Inspire',
            companyAddress: 'PO Box 227',
            companyCity: 'Rotherham',
            companyPostcode: 'S98 1PB',
            date: '24 December 2025',
            ref: 'REF:2AB',
            customerId: 'CUS23',
            subject: 'Your Service Appointment',
            message: 'We have an important update regarding your upcoming service visit.',
        },
        {
            id: 4,
            name: 'James Taylor',
            email: 'james.taylor@example.com',
            phone: '+44 7700 900321',
            address: '321 High Street',
            city: 'Leeds',
            postcode: 'LS1 1AA',
            company: 'Go Inspire',
            companyAddress: 'PO Box 227',
            companyCity: 'Rotherham',
            companyPostcode: 'S98 1PB',
            date: '24 December 2025',
            ref: 'REF:5CD',
            customerId: 'CUS34',
            subject: 'Annual Service Reminder',
            message: 'It\'s time for your annual service check. We\'d like to schedule a convenient time for your visit.',
        },
    ];

    const getChannels = () => {
        if (actualChannels.length > 0) return actualChannels;

        if (format === 'MULTICHANNEL' || format === 'MULTI CHANNEL' || format === 'multiChannel' || format === 'HYBRID') {
    return [
        ...(totalProofCount.print > 0 ? [{ id: 'PRINT', label: 'PRINT', count: totalProofCount.print || 0 }] : []),
        ...(totalProofCount.email > 0 ? [{ id: 'EMAIL', label: 'EMAIL', count: totalProofCount.email || 0 }] : []),
        // { id: 'SMS', label: 'SMS', count: mockProofs.length },
    ];
}
        return [{ id: format, label: format?.toUpperCase(), count: totalProofCount[selectedChannel?.toLowerCase()] }];
    };

    const channels = getChannels();

    const getProofsForChannel = () => {
        if (!proofs || proofs.length === 0) return mockProofs;
        return proofs.filter(p => p.channel === selectedChannel);
    };

    const channelProofs = getProofsForChannel();
    const maxProofNumber = proffDataList?.length || 0;

    const handleChannelChange = (channelId) => {
        setSelectedFilters([]);
        setShowSearch(false);
        setIsLoading(true);
        setSelectedChannel(channelId);
        getProofsListForMultiChannel(channelId);
        setSelectedProofNumber(0);
    };

    const handlePrevProof = () => {
        if (selectedProofNumber > 0) {
            const newIndex = selectedProofNumber - 1;
            setSelectedProofNumber(newIndex);
            setIsLoading(true);
            (selectedChannel?.toLowerCase() === 'print' || format?.toLowerCase() === 'print')
                ? getPreview(
                    proffDataList[newIndex]?.documentURL,
                    proffDataList[newIndex]?.dataSet
                )
                : getEmailPreview(
                    proffDataList[newIndex]?.documentURL,
                    proffDataList[newIndex]?.dataSet
                );
        }
    };

    const handleNextProof = () => {
        if (selectedProofNumber < maxProofNumber - 1) {
            const newIndex = selectedProofNumber + 1;
            setSelectedProofNumber(newIndex);

            selectedChannel?.toLowerCase() === 'print'
                ? getPreview(
                    proffDataList[newIndex]?.documentURL,
                    proffDataList[newIndex]?.dataSet
                )
                : getEmailPreview(
                    proffDataList[newIndex]?.documentURL,
                    proffDataList[newIndex]?.dataSet
                );
        }
    };

    const handleSearchToggle = () => {
        setShowSearch(!showSearch);
        setSearchQuery('');
    };

    const handleSearchChange = (e) => setSearchQuery(e.target.value);

    const handleSelectFirst5 = async () => {
        try {
            await getProofsList();
        }
        catch (error) {
            console.error("Failed to fetch first proofs:", error);
            message.error(t(trans.PROOFS_FETCH_FAILED.key, trans.PROOFS_FETCH_FAILED.value));
        }
        setSelectedProofs(proffDataList.length);
        setSelectedProofNumber(0);
    };

    const handleSelectLast5 = async () => {
        try {
            await getProofsList(4, true);
        }
        catch (error) {
            console.error("Failed to fetch last proofs:", error);
            message.error(t(trans.PROOFS_FETCH_FAILED.key, trans.PROOFS_FETCH_FAILED.value));
        }
        setSelectedProofs(proffDataList.length);
        setSelectedProofNumber(0);
    };

    const getFilteredProofs = () => {
        if (!searchQuery) return mockProofs;
        const query = searchQuery?.toLowerCase();
        return mockProofs.filter(proof =>
            proof.name?.toLowerCase().includes(query) ||
            proof.email?.toLowerCase().includes(query) ||
            proof.phone.includes(query) ||
            proof.city?.toLowerCase().includes(query) ||
            proof.postcode?.toLowerCase().includes(query) ||
            proof.ref?.toLowerCase().includes(query) ||
            proof.customerId?.toLowerCase().includes(query)
        );
    };

    const filteredProofs = getFilteredProofs();

    const previewPortalContainerId = 'preview-portal';

    const valueDataSet = useMemo(() => {
        const data = {};
        metaKeys.forEach(key => {
            data[key.charAt(0).toUpperCase() + key.slice(1)] = [...new Set(mockProofs.map(p => p[key]))];
        });
        return data;
    }, [mockProofs]);

    const handleApproveProofs = async () => {
      setIsApproving(true);
      try {
        await proofApproval({ batchId, proofsApproved: true });
      } catch (error) {
        console.error('Proof approval failed:', error);
        message.error(t(trans.PROOF_APPROVAL_FAILED.key, trans.PROOF_APPROVAL_FAILED.value));
      } finally {
        setIsApproving(false);
      }
    };

    const handleProofSelect = index => {
        if(index !== selectedProofNumber) {
            setIsLoading(true);
            format.toLowerCase() === 'print' || selectedChannel.toLowerCase() === 'print'
                ? getPreview(proffDataList[index]?.documentURL, proffDataList[index]?.dataSet)
                : getEmailPreview(proffDataList[index]?.documentURL, proffDataList[index]?.dataSet);
            setSelectedProofNumber(index);
        }
    };

    return (
        <S.PVContainer>
            <S.PVControlsWrapper>
                <S.PVFlexRow>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <S.PVSectionHeader>{t(trans.PROOFS_HEADER.key, trans.PROOFS_HEADER.value)}</S.PVSectionHeader>
                        {channels.map((channel) => (
                            <S.PVTabButton
                                key={channel.id}
                                active={selectedChannel === channel.id}
                                onClick={() => handleChannelChange(channel.id)}
                            >
                                {channel.label} {channel.count > 0 && ` (${channel.count})`}
                            </S.PVTabButton>
                        ))}
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {proffDataList?.length > 0 && <S.PVSectionHeader>{t(trans.SELECT_PROOF_HEADER.key, trans.SELECT_PROOF_HEADER.value)}</S.PVSectionHeader>}
                            {Array.from({ length: proffDataList?.length }, (_, index) => (
                                <S.PVProofNumberButton
                                    key={index}
                                    active={selectedProofNumber === index}
                                    onClick={() => handleProofSelect(index)}
                                >
                                    #{index + 1}
                                </S.PVProofNumberButton>
                            ))}
                        </div>

                        {selectedChannel?.toUpperCase() === 'EMAIL' && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <S.PVSectionHeader>{t(trans.VIEW_MODE_HEADER.key, trans.VIEW_MODE_HEADER.value)}</S.PVSectionHeader>
                                <S.PVViewModeButton
                                    active={viewMode === 'desktop'}
                                    onClick={() => { setCurrentView(2); setViewMode('desktop') }}
                                >
                                    <Icon type="desktop" />
                                    {t(trans.DESKTOP_MODE.key, trans.DESKTOP_MODE.value)}
                                </S.PVViewModeButton>
                                <S.PVViewModeButton
                                    active={viewMode === 'mobile'}
                                    onClick={() => { setCurrentView(3); setViewMode('mobile') }}
                                >
                                    <Icon type="mobile" />
                                    {t(trans.MOBILE_MODE.key, trans.MOBILE_MODE.value)}
                                </S.PVViewModeButton>
                            </div>
                        )}
                    </div>
                </S.PVFlexRow>

                <S.PVQuickActionsArea>
                    <S.PVSectionHeader>{t(trans.QUICK_ACTIONS_HEADER.key, trans.QUICK_ACTIONS_HEADER.value)}</S.PVSectionHeader>
                    {totalProofCount[selectedChannel?.toLowerCase()] > 5 && <S.PVActionButton variant="cyan" onClick={handleSelectFirst5}>
                        {t(trans.FIRST_5_PROOFS.key, trans.FIRST_5_PROOFS.value)}
                    </S.PVActionButton>}
                    {totalProofCount[selectedChannel?.toLowerCase()] > 5 && <S.PVActionButton variant="cyan" onClick={handleSelectLast5}>
                        {t(trans.LAST_5_PROOFS.key, trans.LAST_5_PROOFS.value)}
                    </S.PVActionButton>}
                    <S.PVActionButton active={showSearch} onClick={handleSearchToggle}>
                        <Icon type="search" />
                        {t(trans.SEARCH_PROOFS.key, trans.SEARCH_PROOFS.value)}
                    </S.PVActionButton>

                    {showSearch && (
                        <S.PVSearchContainer style={{ width: '100%', maxWidth: '600px' }}>
                            <ProofSearchSelect
                                setNoSearchResult={setNoSearchResult}
                                setProffDataList={setProffDataList}
                                setTotalProofCount={setTotalProofCount}
                                setPdfUrl={setPdfUrl}
                                setIsLoading={setIsLoading}
                                selectedChannel={selectedChannel}
                                getEmailPreview={getEmailPreview}
                                getPreview={getPreview}
                                keyDataSet={metaKeys}
                                valueDataSet={valueDataSet}
                                selectedFilters={selectedFilters}
                                setSelectedFilters={setSelectedFilters}
                                placeholder={t(trans.SEARCH_KEY_VALUE_PLACEHOLDER.key, trans.SEARCH_KEY_VALUE_PLACEHOLDER.value)}
                                fullWidth
                                isDynamicKeyValue
                                allowValuesforKeys={metaKeys}
                                batchId={batchId}
                                format={format}
                            />
                        </S.PVSearchContainer>
                    )}

                    {selectedFilters.length > 0 && <S.PVActionButton disableAction>{proffDataList?.length || 0}{' '}{t(trans.RESULTS_LABEL.key, trans.RESULTS_LABEL.value)}</S.PVActionButton>}

                    {/* {showSearch && searchQuery && (
                        <Badge
                            count={filteredProofs.length}
                            style={{ backgroundColor: '#f3f4f6', color: '#374151', boxShadow: 'none', border: 'none' }}
                        />
                    )} */}
                </S.PVQuickActionsArea>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '12px', paddingTop: "12px" }}>
                    {isLoading && selectedFilters.length > 0 ? <div style={{ paddingBlock: '24px', gridColumn: '1 / -1', textAlign: 'center', justifySelf: 'center' }}><Spin /></div>
                    : selectedFilters.length > 0 && proffDataList?.length > 0 ? 
                    <>
                    <div style={{ gridColumn: '1 / -1', textAlign: 'left' }}><S.PVSectionHeader>{t(trans.SEARCH_RESULTS.key, trans.SEARCH_RESULTS.value)}</S.PVSectionHeader></div>
                    {proffDataList?.slice(0, 4).map((proof, index) => {
                            return (
                            <S.PVSearchResult key={index} onClick={() => handleProofSelect(index)} active={selectedProofNumber === index}>
                                <div className='proof-index'>#{index+1}</div>
                                {Object.entries(proof?.dataSet).map(([key, value]) => (
                                    <p key={key}>
                                        {key}: {typeof value === "object" && value !== null
                                        ? JSON.stringify(value)
                                        : value}
                                    </p>
                                ))}
                            </S.PVSearchResult>
                            );
                        })}
                    </>
                    : null}

                    {noSearchResult && selectedFilters.length > 0 && <div style={{ paddingBlock: '24px', gridColumn: '1 / -1', textAlign: 'center', justifySelf: 'center' }}>
                        <Icon type="search" /><br />
                        <strong>{t(trans.NO_PROOFS_FOUND.key, trans.NO_PROOFS_FOUND.value)}</strong>
                        <p>{t(trans.TRY_DIFFERENT_SEARCH.key, trans.TRY_DIFFERENT_SEARCH.value)}</p>
                    </div>}
                </div>

                {showSearch && searchQuery && filteredProofs.length > 0 && (
                    <S.PVResultsGrid>
                        {filteredProofs.map((proof) => (
                            <S.PVResultButton
                                key={proof.id}
                                onClick={() => {
                                    setSelectedProofNumber(proof.id);
                                    setShowSearch(false);
                                    setSearchQuery('');
                                }}
                            >
                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#1f2937', marginBottom: '4px' }}>#{proof.id} - {proof.name}</div>
                                <div style={{ fontSize: '12px', color: '#6b7280' }}>
                                    <div>{proof.email}</div>
                                    <div>{proof.city} - {proof.postcode}</div>
                                    <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
                                        <span style={{ backgroundColor: '#f3f4f6', padding: '2px 8px', borderRadius: '4px' }}>{proof.ref}</span>
                                        <span style={{ backgroundColor: '#f3f4f6', padding: '2px 8px', borderRadius: '4px' }}>{proof.customerId}</span>
                                    </div>
                                </div>
                            </S.PVResultButton>
                        ))}
                    </S.PVResultsGrid>
                )}

                {showSearch && searchQuery && filteredProofs.length === 0 && (
                    <div style={{ marginTop: '16px', paddingTop: '16px', borderTop: '1px solid #e5e7eb', textAlign: 'center', padding: '32px 0' }}>
                        <Icon type="search" style={{ fontSize: '32px', color: '#9ca3af', marginBottom: '8px' }} />
                        <div style={{ fontSize: '14px', fontWeight: '600', color: '#4b5563' }}>{t(trans.NO_PROOFS_FOUND.key, trans.NO_PROOFS_FOUND.value)}</div>
                        <div style={{ fontSize: '12px', color: '#6b7280' }}>{t(trans.TRY_DIFFERENT_SEARCH.key, trans.TRY_DIFFERENT_SEARCH.value)}</div>
                    </div>
                )}
            </S.PVControlsWrapper>

            <S.PVPreviewArea>
                <S.PVNavArrow
                    direction="left"
                    onClick={handlePrevProof}
                    disabled={selectedProofNumber === 0}
                >
                    <Icon type="left" />
                </S.PVNavArrow>

                <S.PVNavArrow
                    direction="right"
                    onClick={handleNextProof}
                    disabled={selectedProofNumber === maxProofNumber - 1}
                >
                    <Icon type="right" />
                </S.PVNavArrow>

                <S.PVDocumentPreview>
                    <S.PVPaper mode={viewMode}>
                        {(format === 'PRINT' || selectedChannel?.toLowerCase() === 'print') && (isLoading ?
                            <LoaderContainer style={{ marginTop: '40%' }}>
                                <Loader />
                            </LoaderContainer> : pdfurl ?
                                    <Document
                                        key={pdfurl}
                                        loading={<Loader />}
                                        file={pdfurl}
                                        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                                        error={t(trans.FAILED_TO_LOAD_PDF.key, trans.FAILED_TO_LOAD_PDF.value)}
                                    >
                                        {numPages &&
                                            Array.from(new Array(numPages), (_, index) => (
                                                <Page key={index} scale={2} pageNumber={index + 1} renderTextLayer={false}/>
                                            ))}
                                </Document> : noSearchResult? (
                                    <div style={{ textAlign: 'center', padding: '160px 0', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <Icon type="file-pdf" style={{ fontSize: '64px', color: '#d1d5db', marginBottom: '16px' }} />
                                        <div style={{ fontSize: '16px', fontWeight: '600', color: '#4b5563' }}>{t(trans.NO_DOCUMENTS_FOUND.key, trans.NO_DOCUMENTS_FOUND.value)}</div>
                                        <div style={{ fontSize: '14px', color: '#6b7280', marginTop: '8px' }}>{t(trans.CLEAR_FILTERS_OR_MODIFY.key, trans.CLEAR_FILTERS_OR_MODIFY.value)}</div>
                                    </div>
                                ) : isNoDocUrlFound ? 
                                (
                                    <div style={{ textAlign: 'center', padding: '160px 0', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <Icon type="file-pdf" style={{ fontSize: '64px', color: '#d1d5db', marginBottom: '16px' }} />
                                        <div style={{ fontSize: '16px', fontWeight: '600', color: '#4b5563' }}>{t(trans.NO_DOCUMENTS_FOUND.key, trans.NO_DOCUMENTS_FOUND.value)}</div>
                                    </div>
                                ) : null
                        )}
                        {(format === 'EMAIL' || selectedChannel?.toLowerCase() === 'email') &&
                            (isLoading ?
                                <LoaderContainer style={{ marginTop: '25%' }}>
                                    <Loader />
                                </LoaderContainer> : <PreviewIframe style={{ position: 'relative', top: 4, height: 'calc(100vh - 150px)' }} currentView={currentView}>
                                    {noSearchResult ? (
                                        <div style={{ textAlign: 'center', padding: '160px 0', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <Icon type="mail" style={{ fontSize: '64px', color: '#d1d5db', marginBottom: '16px' }} />
                                            <div style={{ fontSize: '16px', fontWeight: '600', color: '#4b5563' }}>{t(trans.NO_EMAIL_PREVIEW.key, trans.NO_EMAIL_PREVIEW.value)}</div>
                                            <div style={{ fontSize: '14px', color: '#6b7280', marginTop: '8px' }}>{t(trans.CLEAR_FILTERS_OR_MODIFY_EMAIL.key, trans.CLEAR_FILTERS_OR_MODIFY_EMAIL.value)}</div>
                                        </div>
                                    ) : emailData ? <iframe srcDoc={emailData} style={{ width: '100%', height: 'calc(100vh - 175px)' }} /> 
                                    : isNoDocUrlFound ? 
                                    (
                                        <div style={{ textAlign: 'center', padding: '160px 0', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <Icon type="mail" style={{ fontSize: '64px', color: '#d1d5db', marginBottom: '16px' }} />
                                            <div style={{ fontSize: '16px', fontWeight: '600', color: '#4b5563' }}>{t(trans.NO_EMAIL_PREVIEW.key, trans.NO_EMAIL_PREVIEW.value)}</div>
                                        </div>
                                    ) :
                                    null}
                                </PreviewIframe>
                            )}
                    </S.PVPaper>
                </S.PVDocumentPreview>
            </S.PVPreviewArea>

            {<S.PVApprovalSection>
                <S.PVApprovalFlex>
                    <S.PVIconBox>
                        <Icon type="file-text" style={{ fontSize: '20px', color: '#ffffff' }} />
                    </S.PVIconBox>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                        <h3 style={{ fontSize: '14px', fontWeight: '700', color: '#1f2937', marginBottom: '8px' }}>{isProofsTab ? t(trans.APPROVED_PROOFS_TITLE.key, trans.APPROVED_PROOFS_TITLE.value) : t(trans.APPROVE_PROOFS_TITLE.key, trans.APPROVE_PROOFS_TITLE.value)}</h3>
                        <p style={{ fontSize: '12px', color: '#4b5563', marginBottom: '16px' }}>
                            {isProofsTab ? t(trans.APPROVED_PROOFS_DESC.key, {
                                channel: selectedChannel,
                                defaultValue: trans.APPROVED_PROOFS_DESC.value,
                            }) : t(trans.APPROVE_PROOFS_DESC.key, {
                                channel: selectedChannel,
                                defaultValue: trans.APPROVE_PROOFS_DESC.value,
                            })}
                        </p>
                        <S.PVApprovalButton
                            approved={isApproved.current || isProofsTab}
                            disabled={isApproving}
                            onClick={() => { if (proofsApproved || isApproving || isProofsTab) return; isApproved.current = !isApproved.current; handleApproveProofs(); setProofsApproved(!!isApproved.current) }}
                        >
                            {isApproving && <Icon type="loading" style={{ marginRight: '8px' }} />}
                            {proofsApproved || isProofsTab
                                ? t(trans.PROOFS_APPROVED_BUTTON.key, trans.PROOFS_APPROVED_BUTTON.value)
                                : t(trans.APPROVE_PROOFS_BUTTON.key, trans.APPROVE_PROOFS_BUTTON.value)}
                        </S.PVApprovalButton>
                    </div>
                </S.PVApprovalFlex>
            </S.PVApprovalSection>}
        </S.PVContainer>
    );
}




